import RequestBase from './RequestBase';

export class CreateCredentialsRequest extends RequestBase {
    constructor(username, password) {
        super();
        this._url = '/Credentials';
        this.method = 'POST';
        this.contentType = 'application/json';
        this.anonymous = true;
        this.parameters = [
            'username',
            'password'
        ];
        this.body = {
            'username': username,
            'password': password
        };
    }
}

export class UpdateCredentialsRequest extends RequestBase {
    constructor(username, password) {
        super();
        this._url = '/Credentials';
        this.method = 'PATCH';
        this.contentType = 'application/json';
        this.anonymous = true;
        this.parameters = [
            'username',
            'password'
        ];
        this.body = {
            'username': username,
            'password': password
        };
    }
}



// WEBPACK FOOTER //
// ./src/Resources/Credentials.js